import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useTheme } from 'styled-components';
import Div from '../div';
import Typography from '../typography';
import { InformationRowSizeThemes } from './sizes';
import { InformationRowContainer } from './styles';
const InformationRowVertical = ({ label, value, Icon, size = 'md', }) => {
    const theme = useTheme();
    const sizeTheme = useMemo(() => InformationRowSizeThemes[size], [size]);
    if (!value)
        return null;
    return (_jsxs(InformationRowContainer, { "$type": "vertical", "$size": size, children: [_jsxs(Div, { flex: "row", fitContent: true, align: "center", gap: theme.spacing.sm, children: [Icon && _jsx(Icon, { size: sizeTheme.icon, color: theme.colors.grey_2 }), _jsx(Typography, { elementTheme: sizeTheme.label, color: theme.colors.grey_2, children: label })] }), _jsx(Typography, { style: { paddingInlineStart: theme.spacing.sm + sizeTheme.icon }, elementTheme: sizeTheme.value, children: value })] }));
};
const InformationRowHorizontal = ({ label, value, Icon, size = 'md', }) => {
    const theme = useTheme();
    const sizeTheme = useMemo(() => InformationRowSizeThemes[size], [size]);
    if (!value)
        return null;
    return (_jsxs(InformationRowContainer, { "$type": "horizontal", "$size": size, children: [_jsxs(Div, { flex: "row", fitContent: true, align: "center", gap: theme.spacing.sm, children: [Icon && _jsx(Icon, { size: sizeTheme.icon, color: theme.colors.grey_2 }), _jsx(Typography, { elementTheme: sizeTheme.value, color: theme.colors.grey_2, children: label })] }), _jsx(Typography, { elementTheme: sizeTheme.value, children: value })] }));
};
const InformationRowValueOnly = ({ value, size = 'md', Icon, }) => {
    const theme = useTheme();
    const sizeTheme = useMemo(() => InformationRowSizeThemes[size], [size]);
    if (!value)
        return null;
    return (_jsxs(InformationRowContainer, { "$type": "valueOnly", "$size": size, children: [Icon && _jsx(Icon, { size: sizeTheme.icon, color: theme.colors.grey_1 }), _jsx(Typography, { elementTheme: sizeTheme.value, color: theme.colors.grey_1, children: value })] }));
};
const InformationRow = (props) => {
    switch (props.type) {
        case 'vertical':
            return _jsx(InformationRowVertical, Object.assign({}, props));
        case 'horizontal':
            return _jsx(InformationRowHorizontal, Object.assign({}, props));
        case 'valueOnly':
            return _jsx(InformationRowValueOnly, Object.assign({}, props));
        default:
            return _jsx(InformationRowHorizontal, Object.assign({}, props));
    }
};
export default InformationRow;
